<template>
    <div class="greybox">
        <h1>Where would you like us to come...</h1>
        
        <label class="check-container mt-5">Use address entered on claim form.
            <input type="checkbox" v-model="useAddress">
            <span class="check-checkmark"></span>
        </label>
        <div v-show="!useAddress" class="mb-3">
            <label class="mt-5"><strong>Or enter a postcode to search for alternate address</strong></label >
            <input
                type="text"
                class=""
                id="postcode"
                placeholder=""
                v-model="searchPostcode">
            <div
                v-if="!isSearchPostcodeValid && submitAttempt"
                class="text-danger">
                <small>Please enter a postcode</small>
            </div>
            <button
                class="button-small my-2 my-sm-0"
                @click="initBooking()">
                Search
            </button>

            <transition name="fade" mode="in-out">
                <div v-if="autoAddresses && autoAddresses.length > 0">
                    <label class="mt-5"><strong>Select an address or search again</strong></label >
                    <select
                        id="selectedAddress"
                        v-model="selectedAddress">
                        <option
                            v-for="(address, index) in autoAddresses"
                            :key="index"
                            :value="address">
                            {{Object.keys(address).map((k) => {return address[k]}).join(", ")}}
                        </option>
                    </select>
                    <div
                        v-if="!isSelectedAddressValid && nextAttempt"
                        class="text-danger">
                        <small>Please select the address</small>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div
                    v-if="searchPostcodeMsg"
                    class="text-danger mt-5 mb-5">
                    <i class="fas fa-exclamation-triangle mr-2"></i><strong>{{searchPostcodeMsg}}</strong>
                </div>
            </transition>
        </div>
         <transition name="fade">
            <div
                v-if="bookingExists"
                class="text-danger mt-5 mb-3">
                <i class="fas fa-exclamation-triangle mr-2"></i><strong>There is already a booking for this gadget.  <router-link to="/myclaims/repairoptions/bookinginfo">Click here</router-link> to view the details.</strong>
            </div>
        </transition>
        <div class="button-fluid-container">
            <button class="button" @click="handleBackClick()">Back</button>
            <button class="button" @click="handleContinueClick()">Continue</button>
        </div>        

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>
<script>
import onsiteBooking from '@/components/OnsiteBooking.vue'
import repairOptionsBase from '@/mixins/repairOptionsBase'
import loading from 'vue-loading-overlay'

import axios from 'axios'

let baseUrl = process.env.VUE_APP_API_BASE_URL

let initSearch = {
    searchPostcodeMsg: null,
    autoAddresses: () => [],
    //selectedAddress: null
}

let required = (value) => {
  return !(value === undefined || value === null || value === '')
}

let atLeastOne = (value) => {
  return value && value.length > 0
}

export default {
    components: {
        onsiteBooking,
        loading
    },
    mixins: [
        repairOptionsBase
    ],
    data: () => {
        return {
            submitAttempt: false,
            nextAttempt: false,
            useAddress: false,
            searchPostcode: null,
            bookingExists: false,
            ...initSearch,
            //isLoading:false
            //modelVersions: [],
            //bookingReference: null
        }
    },
    computed: {
        isSearchPostcodeValid () {
            return required(this.searchPostcode)
        },
        isSelectedAddressValid () {
            return required(this.selectedAddress)
        },
        isFormValid () {
            return this.isSearchPostcodeValid
        }
    },
    mounted () { this.isLoading=false /* HACK */ },
    methods: {
        initBooking () {
            this.isLoading = true
            this.searchPostcodeMsg = null
            this.submitAttempt = true
            this.selectedAddress = null

            if (this.isFormValid) {
                if (this.selectedGadgetId) {
                    axios
                    .get(baseUrl + '/api/v1/booking/' + this.selectedGadgetId + '/' + this.searchPostcode)
                    .then(response => {

                        let {modelVersions, bookingReference, autoAddresses, errorCode } = response.data.data

                        this.modelVersions = modelVersions
                        this.bookingReference = bookingReference
                        this.autoAddresses = autoAddresses

                        this.handleErrorCode(errorCode)
                        this.isLoading=false
                    })
                    .catch(error => {
                        this.isLoading = false
                    })
                    .finally(() => {})
                }
            }
        },
        handleErrorCode (errorCode) {
            if (errorCode == 3) {
                this.searchPostcodeMsg = 'Sorry!  We have no technician available in that area.'
            }

            if (errorCode == 2) {
                this.searchPostcodeMsg = 'Please check the postcode that you have entered..'
            }

            // Booking alread exists in our DB for this gadget
            if (errorCode == 1000) {
                this.bookingExists = true
            }
        },
        handleBackClick () {
            this.$router.push({path: '/myclaims/repairoptions/info/'})
        },
        handleContinueClick () {
            this.nextAttempt = true
            // Is useAddress selected? Y = carry out init with just gadget id
            // handle error
            // send to next stage (as above)
            if (this.useAddress) {
                this.isLoading = true
                axios
                    .get(baseUrl + '/api/v1/booking/' + this.selectedGadgetId)
                    .then(response => {
                    let {modelVersions, bookingReference, autoAddresses, errorCode } = response.data.data

                        this.modelVersions = modelVersions
                        this.bookingReference = bookingReference
                        this.autoAddresses = autoAddresses

                        this.handleErrorCode(errorCode)
                        this.isLoading = false
                        if (this.modelVersions && this.modelVersions.length > 0) {
                            this.$router.push({path: '/myclaims/repairoptions/bookingmod'})
                        }
                    })
                    .catch(error => {
                        this.isLoading = false
                    })
                    .finally(() => {})
            } else {
                // have we gor a booking ref? Y = changed address
                // send to next stage (once everything is in state)
                if (this.bookingReference) {
                    if (this.modelVersions && this.modelVersions.length > 0) {
                        this.$router.push({path: '/myclaims/repairoptions/bookingmod'})
                    }
                }
            }
        }
    }
}
</script>
